import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class NitrateSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.NitrateSensor,
    });
  }
}
